import React from 'react';
import _SupportInfoContainer from './_SupportInfoContainer.scss';
import {ArticleItem} from 'components/home/sub-view/Article';
import {Articles} from 'api';
import {Link, withRouter} from 'react-router-dom';

class SupportInfoContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {}
  }

  render() {
    return (
      <div className='wrap-support-container'>
        <div className='center'>
          <div className="row">
            <div className='item-support-container'>
              <div className='wrap-image-support-container'>
                <Link to='cms/vitrade-va-cach-vn-hanh' className='img-link'>
                  <img className='image-support-container' src={require('assets/images/partials/bao-mat-thanh-toan.jpg')} alt=''/>
                </Link>
              </div>
              <h3 className='title-black'>
                <Link to='cms/vitrade-va-cach-vn-hanh' className='title-link'>Bảo mật thanh toán</Link>
              </h3>
              <p className='support-container-description'>Nunc facilisis eu enim non sodales</p>
              <p className='support-container-link'>
                <Link to='cms/vitrade-va-cach-vn-hanh' className='view-more'>Xem chi tiết</Link>
              </p>
            </div>

            <div className='item-support-container'>
              <div className='wrap-image-support-container'>
                <Link to='cms/tr-thanh-vitrader' className='img-link'>
                  <img className='image-support-container' src={require('assets/images/partials/doanh-nghiep-xac-nhan.jpg')} alt=''/>
                </Link>
              </div>
              <h3 className='title-black'>
                <Link to='cms/tr-thanh-vitrader' className='title-link'>100% doanh nghiệp đã xác nhận</Link>
              </h3>
              <p className='support-container-description'>Nunc facilisis eu enim non sodales</p>
              <p className='support-container-link'>
                <Link to='cms/tr-thanh-vitrader' className='view-more'>Xem chi tiết</Link>
              </p>
            </div>

            <div className='item-support-container'>
              <div className='wrap-image-support-container'>
                <Link to='cms/tr-thanh-vitrader' className='img-link'>
                  <img className='image-support-container' src={require('assets/images/partials/cham-soc-khach-hang.jpg')} alt=''/>
                </Link>
              </div>
              <h3 className='title-black'>
                <Link to='cms/tr-thanh-vitrader' className='title-link'>Hỗ trợ tư vấn doanh nghiệp</Link>
              </h3>
              <p className='support-container-description'>Nunc facilisis eu enim non sodales</p>
              <p className='support-container-link'>
                <Link to='cms/tr-thanh-vitrader' className='view-more'>Xem chi tiết</Link>
              </p>
            </div>

            <div className='item-support-container'>
              <div className='wrap-image-support-container'>
                <Link to='cms/nha-cung-cp-uy-tin' className='img-link'>
                  <img className='image-support-container' src={require('assets/images/partials/ho-tro-di-dong.jpg')} alt=''/>
                </Link>
              </div>
              <h3 className='title-black'>
                <Link to='cms/nha-cung-cp-uy-tin' className='title-link'>Hỗ trợ di động, làm việc bất cứ đâu</Link>
              </h3>
              <p className='support-container-description'>Nunc facilisis eu enim non sodales</p>
              <p className='support-container-link'>
                <Link to='cms/nha-cung-cp-uy-tin' className='view-more'>Xem chi tiết</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SupportInfoContainer);



// WEBPACK FOOTER //
// ./components/home/sub-view/SupportInfoContainer.jsx